import type { AccessibleFleet } from '@cobliteam/common-types';
import { useUser } from '@cobliteam/hooks';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import Divider from '@cobliteam/ui/components/Divider';
import type React from 'react';
import AppFleetSwitcher from '../AppFleetSwitcher';
import MultiSelectVehicleGroupsSidebar from '../MultiSelects/MultiSelectVehicleGroupsSidebar';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, useSidebar } from './components/Sidebar';
import { SidebarMenu } from './components/SidebarMenu';
import { SidebarUpdate } from './components/SidebarUpdate';
import sidebarDef from './sidebarDef';
interface AppSidebarProps extends React.ComponentProps<typeof Sidebar> {
  fleets: AccessibleFleet[];
  currentFleet: AccessibleFleet;
}

const SIDEBAR_CONTENT_HEIGHT_OPENED = 'h-[calc(100vh-154px)]'; // 154px is the height of the header
const SIDEBAR_CONTENT_HEIGHT_CLOSED = 'h-[calc(100vh-144px)]'; // 174px is the height of the header

// map = z-index 400
// map controls = z-index 800
const SIDEBAR_Z_INDEX = 'z-sidebar'; // 1200

function AppSidebar({ fleets, currentFleet, ...props }: AppSidebarProps) {
  const featureFlags = useFeatureFlags();
  const { state } = useSidebar();
  const { data: userData } = useUser().useGetUserData();
  const hasCameraFlag = userData?.hasCameraFlag;
  const isCollapsed = state === 'collapsed';
  const sidebarHeight = isCollapsed ? SIDEBAR_CONTENT_HEIGHT_CLOSED : SIDEBAR_CONTENT_HEIGHT_OPENED;
  return (
    <>
      <Sidebar variant='sidebar' collapsible='icon' className={SIDEBAR_Z_INDEX} {...props}>
        <SidebarHeader>
          <AppFleetSwitcher fleets={fleets} currentFleet={currentFleet} />
          <MultiSelectVehicleGroupsSidebar newSidebar />
        </SidebarHeader>
        <Divider className='mb-3 bg-gray-11' />
        <SidebarContent className={sidebarHeight}>
          <SidebarMenu featureFlags={featureFlags} sidebarDef={sidebarDef({ featureFlags, hasCameraFlag })} />
        </SidebarContent>
        <SidebarFooter>
          <SidebarUpdate />
        </SidebarFooter>
      </Sidebar>
    </>
  );
}

export default AppSidebar;
